import React, { useEffect, useState } from "react";

const GoogleTranslate = () => {
  const [lang, setLang] = useState("es");

  useEffect(() => {
    const savedLang = localStorage.getItem("lang") || "es";
    setLang(savedLang);

    const addScript = () => {
      if (document.getElementById("google-translate-script")) return;

      window.googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: "es",
            includedLanguages: "en,es",
            autoDisplay: false,
          },
          "google_translate_element"
        );

        applyLanguage(savedLang);
      };

      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    };

    addScript();
  }, []);

  const applyLanguage = (language) => {
    document.cookie = `googtrans=/es/${language};path=/`;

    const select = document.querySelector(".goog-te-combo");

    if (select) {
      select.value = language;
      select.dispatchEvent(new Event("change"));
    }
  };

  const changeLanguage = (language) => {
    localStorage.setItem("lang", language);
    setLang(language);
    applyLanguage(language);
  };

  return (
    <div className="lang-switch">
      <button
        className={lang === "es" ? "active" : ""}
        onClick={() => changeLanguage("es")}
      >
        🇪🇸 ES
      </button>

      <button
        className={lang === "en" ? "active" : ""}
        onClick={() => changeLanguage("en")}
      >
        🇺🇸 EN
      </button>

      <div id="google_translate_element" style={{ display: "none" }}></div>
    </div>
  );
};

export default GoogleTranslate;